import { ModalTabs, ModalTab } from "../../../components/ModalTabs";
import type { TRangeSelection } from "../../useRangeSelectionChange";
import type { TConditionalFormattingRule } from "../../../../data";
import { useModalDragConstraint } from "../../../components/Modal";
import { useMemoModal } from "../../../components/Modal";
import { ManageConditionalFormatting } from "./Manage";
import { AddConditionalFormatting } from "./Add";
import { ModalContainer } from "../ModalContainer";

export const useConditionalFormattingModal = () => {
  const constraintRef = useModalDragConstraint();
  const modal = useMemoModal(
    (p: {
      active: "add" | "manage";
      range: TRangeSelection;
      rules: TConditionalFormattingRule[];
      width?: number;
      height?: number;
    }) => {
      return (
        <ModalTabs {...p} constrainRef={constraintRef} onClose={() => modal.close()}>
          <ModalContainer onClose={() => modal.close()}>
            <ModalTab id="add" title="Add conditional formatting">
              <AddConditionalFormatting selection={p.range} />
            </ModalTab>
            <ModalTab id="manage" title="Manage conditional formatting">
              <ManageConditionalFormatting selection={p.range} rules={p.rules} />
            </ModalTab>
          </ModalContainer>
        </ModalTabs>
      );
    },
  );

  return modal;
};
